module.exports = __webpack_public_path__ + "static/media/cfvideo.6dcd3e2f.mov";